module.exports = "<div class=\"toggle\">\r\n    <div class=\"toggle_option\" ng-repeat=\"radio in options\">\r\n        <input type=\"radio\" ng-attr-id=\"{{ctrlName}}_{{$index}}\" ng-model=\"toggle.value\" ng-attr-name=\"{{ctrlName}}\" ng-value=\"radio.value\" class=\"is-hidden\" />\r\n        <label tabindex=\"0\" for=\"{{ctrlName}}_{{$index}}\" class=\"toggle-btn toggle-btn-{{radio.text}}\">\r\n            <span class=\"toggle-btn-display\" ng-bind=\"radio.text\"></span>\r\n        </label>\r\n    </div>\r\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/components/toggle/toggle-template.html
 ** module id = 1037
 ** module chunks = 1
 **/